let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("TpHsp"), load("aDV08")]).then(() => parcelRequire('ef32u'));